let storeInstance = null;

export const bindStore = (store) => {
  storeInstance = store;
};

export const getStore = () => storeInstance;
